import Buttons from "../Buttons";
import Container from "../Container";
import classes from "./index.module.scss";

export default function Footer() {
  return (
    <section className={classes.section}>
      <Container>
        <div className={classes.body}>
          <h2 className={classes.title}>
            Happy to share with you some feedback from Google Play
            <span className={classes.lines}></span>
          </h2>
          <Buttons className={classes.buttons} />
        </div>
      </Container>
    </section>
  );
}
